module.exports = __webpack_public_path__ + "static/img/banner.7a156ae0.png";